import { blackColors } from 'assets/jss/material-dashboard-pro-react';

const detailsRowStyle = () => ({
	row: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginTop: '5px',
		paddingBottom: '2px',
		'& p': {
			marginBottom: 0,
			'&:last-of-type': {
				wordBreak: 'break-all',
				textAlign: 'right',
			},
		},
	},
	rowBorder: {
		borderBottom: `1px solid ${blackColors[6]}`,
	},
});

export default detailsRowStyle;
